import { extractImageCropFromTag } from "@faire/web--source/common/images/cropUtils/extractImageCropFromTag";
import {
  optimizeImageUrl,
  optimizeImageUrlFillSquare,
} from "@faire/web--source/common/images/optimizeImages";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";

import { AVATAR_LARGEST_SIZE } from "./consts";

export const useAvatarImageUrl = (
  image: IImage | undefined
): string | undefined => {
  const isSSR = useIsSSR();

  if (!image) {
    return undefined;
  }

  // we always use the largest size for the avatar, to optimize CDN cache hits
  const imgSize = AVATAR_LARGEST_SIZE;

  if (extractImageCropFromTag(image.tags)) {
    return optimizeImageUrl(image, isSSR, {
      width: imgSize,
      height: imgSize,
    });
  }

  return optimizeImageUrlFillSquare(image, isSSR, imgSize);
};
